<template>
  <v-textarea  v-if="useVuetify" v-bind="$attrs"
                                :rows="rows" :maxlength="maxLength" :placeholder="placeholder" 
                                :model-value="modelValue" @update:modelValue="emit('update:modelValue', $event)">
    <slot></slot>
  </v-textarea >
  <textarea v-else v-bind="$attrs" 
                  ref="textareaRef" :maxlength="maxLength" :placeholder="placeholder"
                  :value ="modelValue" @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"></textarea>  
</template>

<script setup lang="ts">
import { inject, watch, toRefs, ref } from 'vue';

const textareaRef = ref<HTMLTextAreaElement | null>(null);

const props = defineProps({
  height: String,
  rows: String,
  maxLength: Number,
  placeholder: String,
  modelValue: String
})
defineOptions({
  inheritAttrs: false
})

const refs = toRefs(props);
watch(() => refs.height, (newHeight, oldValue) => {
  if (textareaRef.value && newHeight?.value !== oldValue?.value) {
    textareaRef.value.style.height = newHeight?.value ?? "";
  }
});

watch(() => refs.rows, (newRows, oldValue) => {
  if (textareaRef.value && newRows?.value !== oldValue?.value) {
    textareaRef.value.rows = newRows?.value ? newRows.value : "";
  }
});

watch(textareaRef, () => {
  if (textareaRef.value) {
    textareaRef.value.style.height = props.height ?? "";
    textareaRef.value.rows = props.rows ?? "";
  }
}, { once:true});

const emit = defineEmits(['update:modelValue'])
const useVuetify = inject("useVuetify",false);
</script>